import React from 'react';
import { VectorCapitalSimulatorProvider } from './VectorCapitalSimulatorContext';
import '../VectorCapitalPlusSimulator.css';

/**
 * Wraps the Overview dashboard when it contains Vector Capital widgets.
 * Provides shared simulator state; basket modal is rendered by the provider.
 */
export default function VectorCapitalDashboardHost({
  children,
  user,
  isAdmin = false,
  isFullAdmin = false,
  enabled = false,
}) {
  if (!enabled) {
    return children;
  }

  return (
    <VectorCapitalSimulatorProvider
      user={user}
      showEquityPortfolios
      isAdmin={isAdmin}
      isFullAdmin={isFullAdmin}
    >
      <div className="dashboard-vc-layout vector-capital-page">
        {children}
      </div>
    </VectorCapitalSimulatorProvider>
  );
}
